import script from "./payments.vue?vue&type=script&setup=true&lang=js"
export * from "./payments.vue?vue&type=script&setup=true&lang=js"

import "./payments.vue?vue&type=style&index=0&id=34bf0d2a&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bf0d2a"]])

export default __exports__